var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMapBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "62px",
    viewBox: "0 0 38 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "893BDE7F-BB05-4936-B593-B220551E7DE6@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AMP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AMP_v1",
    transform: "translate(-992.000000, -4093.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-yandex-blue",
    transform: "translate(992.066667, 4094.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1642359,25.8059599 C35.4238173,28.5191495 34.6250626,30.7906706 33.7679715,32.6205233 C32.9108804,34.450376 31.3759881,37.161091 29.1632949,40.7526685 L16.1642359,59.943891 L19.4979835,38.0217908 L19.5225135,37.9928345 C27.139953,37.5733453 33.5560701,32.6362077 36.1475188,25.8099936 L36.1642359,25.8059599 Z",
    id: "Combined-Shape",
    fill: "#0056D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6642359,-0.0561090175 C28.8815038,-0.0561090175 37.1642359,8.51223457 37.1642359,19.081822 C37.1642359,29.6514095 28.8815038,38.2197531 18.6642359,38.2197531 C8.44696802,38.2197531 0.164235879,29.6514095 0.164235879,19.081822 C0.164235879,8.51223457 8.44696802,-0.0561090175 18.6642359,-0.0561090175 Z M18.6642359,11.7210793 C14.7345175,11.7210793 11.5488513,15.0165961 11.5488513,19.081822 C11.5488513,23.1470479 14.7345175,26.4425647 18.6642359,26.4425647 C22.5939543,26.4425647 25.7796205,23.1470479 25.7796205,19.081822 C25.7796205,15.0165961 22.5939543,11.7210793 18.6642359,11.7210793 Z",
    id: "Combined-Shape",
    fill: "#0061ED"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapBlue);
export default ForwardRef;